import axios from 'axios'
import {
  CreateOrUpdateGuaranteeRequest, GuaranteeResponse,
} from '../../../../api/models'

const baseUrl = process.env.REACT_APP_API_URL

export async function fetchGuaranteesV2(params: { transitOperationId: number }, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<GuaranteeResponse[]>(`${baseUrl}/v2/guarantee/${params.transitOperationId}`, {
    signal: opts?.signal,
  })

  return data
}

export async function createGuaranteesV2(requests: CreateOrUpdateGuaranteeRequest[]) {
  const { data } = await axios.post<GuaranteeResponse[]>(`${baseUrl}/v2/guarantee`, requests)

  return data
}

export async function createDraftGuaranteesV2(requests: CreateOrUpdateGuaranteeRequest[]) {
  const { data } = await axios.post<GuaranteeResponse[]>(`${baseUrl}/v2/guarantee/draft`, requests)

  return data
}

export async function updateGuaranteesV2(requests: CreateOrUpdateGuaranteeRequest[]) {
  const { data } = await axios.put<GuaranteeResponse[]>(`${baseUrl}/v2/guarantee`, requests)

  return data
}

export async function updateDraftGuaranteesV2(requests: CreateOrUpdateGuaranteeRequest[]) {
  const { data } = await axios.put<GuaranteeResponse[]>(`${baseUrl}/v2/guarantee/draft`, requests)

  return data
}
